import React, { useState, useEffect, useRef } from 'react';
import Header from '../Common_Files/Header';
import Footer from '../Common_Files/Footer';
import config from '../Common_Files/Config';
import ViewProduct from '../Master/ViewProduct';
import ProductList from "./ProductListModel";
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import $ from 'jquery';
import 'datatables.net-bs5';
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import Select from 'react-select';
import { useNavigate } from "react-router-dom";
import { fetchCustomerData, fetchEditCustomerData, handleCustomerChange, fetchWarehouseData, handleProductAdd, handleProductAddNew, handleSalesProductAddNew, getDeliveryAddrById, handleSalesBatchChange, handleSalesBatchChangeEdit, setSalesBatchToProductNew } from '../../services/NewSalesService';
import { fetchProductData, removeRow, handleInputChange, handleInputChangeInSalesNew, handleInputChangeIneditSales } from '../../services/NewPurchaseOrderService';
import CustomDateInput from '../CommonComp/CustomDateInput';
import FormText from '../CommonComp/FormText';

const NewSalesOrderEdit = () => {
  const accessToken = localStorage.getItem('accessToken');
  const [draw, setDraw] = useState(1);
  const [start, setStart] = useState(0);
  const [length, setLength] = useState(50);
  const [deliveryAddresses, setDeliveryAddresses] = useState([]);
  const [inputDeliveryAddresses, setInputDeliveryAddresses] = useState([]);
  const [deliveryAddrDropdown, setDeliveryAddrDropdown] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [invoiceAddress, setInvoiceAddress] = useState([]);
  const [customerData, setCustomerData] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [warehouseData, setWarehouseData] = useState([]);
  const [selectedWarehouseId, setSelectedWarehouseId] = useState(null);
  const [productData, setProductData] = useState([]);
  const [tableRows, setTableRows] = useState([]);
  const [stdGoods, setStdGoods] = useState(0);
  const [vatAmt, setVatAmt] = useState(0);
  const [zeroGoods, setZeroGoods] = useState(0);
  const [grandTotal, setGrandTotal] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [grossWeight, setGrossWeight] = useState(0);
  const [netWeight, setNetWeight] = useState(0);
  const [cube, setCube] = useState(0);
  const [grossProfit, setGrossProfit] = useState(0);
  const [grossProfitPercent, setGrossProfitPercent] = useState(0);
  const [productSO, setProductSO] = useState([]);
  const navigateToOrderHistory = useNavigate();
  const { id } = useParams();
  const [productBatch, setProductBatch] = useState([]);
  const [modalData, setModalData] = useState(null);
  const productBatchRef = useRef(null);
  const AssignBatchModal = useRef(null);
  const [selectedBatchId, setSelectedBatchId] = useState([]);
  const [selectedpurchaseId, setSelectedpurchaseId] = useState([]);
  const [poModalData, setPoModalData] = useState(null);
  const poModalRef = useRef(null);
  const [requiredQty, setRequiredQty] = useState(0);
  const productListRef = useRef(null);
  const [selectedProductId, setSelectedProductId] = useState(null);
  // Validation state variables
  const [fieldErrors, setFieldErrors] = useState({});
  const [jobRefError, setJobRefError] = useState('');
  const [bookingRefError, setBookingRefError] = useState('');
  const [notesError, setNotesError] = useState('');
  const [addressErrors, setAddressErrors] = useState({});

  const [salesInfo, setSalesInfo] = useState({
    delivery_date: '',
    delivery_time: '',
    customer_ref: '',
    job_ref: '',
    booking_ref: '',
    notes: ''
  });
  useEffect(() => {
    console.log('Component loaded with id:', id);
    fetchProductData(setProductData);
    fetchCustomerData(setCustomerData);
    fetchWarehouseData(setWarehouseData);
    handleEditData(id);
  }, []);

  // Debug useEffect to monitor deliveryAddrDropdown state
  useEffect(() => {
    console.log('deliveryAddrDropdown state changed:', deliveryAddrDropdown);
  }, [deliveryAddrDropdown]);
  console.log(modalData);
  const [totalVal, setTotalVal] = useState({
    stdGoods: 0,
    zeroGoods: 0,
    vatAmt: 0,
    grandTotal: 0,
    totalItems: 0,
    grossWeight: 0,
    netWeight: 0,
    cbm: 0,
    totalProfitPercent: 0,
    totalProfit: 0,
  });
  const [salesDesc, setSalesDesc] = useState([]);

  const [deliveryType, setDeliveryType] = useState('');
  const [saveAsProforma, setSaveAsProforma] = useState(false);
  const handleDeliveryandCollectionAddress = (e) => {
    setDeliveryType(e.target.value);
    //setInputDeliveryAddresses([]);
  };
  const [inputCollectionAddresses, setInputCollectionAddresses] = useState({
    address_line1: '',
    address_line2: '',
    city: '',
    country: '',
    post_code: '',
  });


  useEffect(() => {
    $('#dsTable tbody').off('click', '.applybtn');
    $('#dsTable tbody').on('click', '.applybtn', function () {
      $('#freestock').empty();
      $('#stock').empty();
      $('#on_so').empty();
      $('#allocation').empty();
      $('#onpf').empty();
      $('#onpo').empty();
      const product_id = $(this).data('id');
      const formData = new FormData();
      formData.append('id', product_id);
      document.getElementById('viewProductForm').reset();
      const fetchProductData = async () => {
        const apiUrl = `${config.api_url}/ws-get-products-by-id`;
        try {
          const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
              'Authorization': `Bearer ${accessToken}`
            },
            body: formData,
          });

          const data = await response.json();
          $('#code').val(data.products[0].code);
          $('#packValue').val(data.products[0].pack);
          $('#vat').val(data.products[0].vat);
          $('#weight').val(data.products[0].gross_weight);
          $('#supplier').val(data.products[0].supplier_name);
          $('#description').val(data.products[0].product_desc);
          $('#sizeValue').val(data.products[0].size);
          $('#barcode').val(data.products[0].unit_barcode);
          $('#view_case_barcode').val(data.products[0].case_barcode);
          $('#pallet_qty').val(data.products[0].pallet_qty);
          $('#case_price').val(data.products[0].cost);
          $('#view_sell_price').val(data.products[0].price);
          $("#product_status").html(data.products[0].status != 0
            ? 'Status : <span style="margin-left: 5px;" class="badge bg-success">Active</span>'
            : 'Status : <span style="margin-left: 5px;" class="badge bg-secondary"> Inactive</span>'
          );
          $('#viewcbm').val(data.products[0].cbm);
          $('#brandname').val(data.products[0].brand);
          $('#categooryName').val(data.products[0].category);
          $('#editnetWeight').val(data.products[0].net_weight);
          $('#editgrossWeight').val(data.products[0].gross_weight);
          const isDEL001 = data.products[0].code === 'DEL001';
          $('#freestock').append(isDEL001 ? 0 : (data.freestock == null ? 0 : data.freestock));
          $('#stock').append(isDEL001 ? 0 : parseInt(data.products[0].quantity));
          $('#on_so').append(isDEL001 ? 0 : (data.onso == null ? 0 : data.onso));
          $('#allocation').append(isDEL001 ? 0 : (data.allocation == null ? 0 : data.allocation));
          $('#onpf').append(isDEL001 ? 0 : (data.pf == null ? 0 : data.pf));
          $('#onpo').append(isDEL001 ? 0 : (data.on_purchase == null ? 0 : data.on_purchase));
        }
        catch (error) {
          console.error("Error fetching product data:", error);
        }
      };
      fetchProductData();
    });

    return () => {
      $('#dsTable tbody').off('click', '.applybtn');
    };
  }, []);

  const handleOpenProductListModal = (data) => {
    setModalData(data);
    if (productListRef.current) {
      productListRef.current();
    }
  };


  useEffect(() => {
    $('.data').hide();
    $('.clickherebtn').on('click', function (event) {
      event.preventDefault();
      $('.data').toggle();
    });

    return () => {
      $('button').off('click');
    };
  }, []);



  useEffect(() => {
    const calculateTotals = () => {
      const isOutOfUK = invoiceAddress && (invoiceAddress.sales_country === '0' || invoiceAddress.sales_country === 0);
      
      const stdGoods = tableRows
        .filter(item => item.vat != '0.00' && item.vat != null)
        .reduce((sum, item) => {
          const code = String(item.code || '').trim().toUpperCase();
          const isDEL001 = code === 'DEL001';
          if (isDEL001) return sum;
          const itemValue = parseFloat(item.price || 0) * parseFloat(item.pdtqty || 0);
          return sum + itemValue;
        }, 0);

      const zeroGoods = tableRows
        .filter(item => item.vat == '0.00' || item.vat == null)
        .reduce((sum, item) => {
          const code = String(item.code || '').trim().toUpperCase();
          const isDEL001 = code === 'DEL001';
          if (isDEL001) return sum;
          const itemValue = parseFloat(item.price || 0) * parseFloat(item.pdtqty || 0);
          return sum + itemValue;
        }, 0);

      const vatAmt = isOutOfUK ? 0 : tableRows.reduce((sum, item) => {
        const code = String(item.code || '').trim().toUpperCase();
        const isDEL001 = code === 'DEL001';
        if (isDEL001) return sum;
        const baseValue = parseFloat(item.price || 0) * parseFloat(item.pdtqty || 0);
        const itemVat = (baseValue * (parseFloat(item.vat || 0) / 100)) || 0;
        return sum + itemVat;
      }, 0);

      const grandTotal = stdGoods + zeroGoods + vatAmt;

      const totalItems = tableRows.reduce((sum, item) => {
        const itemCount = parseInt(item.pdtqty || 0);
        return sum + itemCount;
      }, 0);

      const grossWeight = tableRows.reduce((sum, item) => {
        if (isSpecialLineItem(item.code)) return sum;
        const grossWeightCount = parseInt(item.pdtqty || 0) * parseFloat(item.grossWeight || 0);
        return sum + grossWeightCount;
      }, 0);

      const netWeight = tableRows.reduce((sum, item) => {
        if (isSpecialLineItem(item.code)) return sum;
        const netWeightCount = parseInt(item.pdtqty || 0) * parseFloat(item.netWeight || 0);
        return sum + netWeightCount;
      }, 0);

      const cbm = tableRows.reduce((sum, item) => {
        if (isSpecialLineItem(item.code)) return sum;
        const cbmCount = parseInt(item.pdtqty || 0) * parseFloat(item.cbm || 0);
        return sum + cbmCount;
      }, 0);

      let totalCost = tableRows.reduce((cost, row) => {
        const code = String(row.code || '').trim().toUpperCase();
        const isDEL001 = code === 'DEL001';
        if (isDEL001) return cost;
        const rowCost = parseFloat(row.cost || 0) * parseFloat(row.pdtqty || 0);
        return cost + rowCost;
      }, 0);
      
      let totalProfit1 = tableRows.reduce((profit, row) => {
        const code = String(row.code || '').trim().toUpperCase();
        const isDEL001 = code === 'DEL001';
        if (isDEL001) {
          const del001Cost = parseFloat(row.cost || 0);
          return profit - del001Cost;
        }
        const rowProfit = ((parseFloat(row.price || 0) - parseFloat(row.cost || 0)) * parseFloat(row.pdtqty || 0));
        return profit + rowProfit;
      }, 0);
      
      const totalRevenue = stdGoods + zeroGoods;
      let totalProfitPercent = totalRevenue > 0 ? (totalProfit1 / totalRevenue) * 100 : 0;

      const totalProfit = tableRows.reduce((profit, row) => {
        const code = String(row.code || '').trim().toUpperCase();
        const isDEL001 = code === 'DEL001';
        if (isDEL001) {
          const del001Cost = parseFloat(row.cost || 0);
          return profit - del001Cost;
        }
        const rowProfit = ((parseFloat(row.price || 0) - parseFloat(row.cost || 0)) * parseFloat(row.pdtqty || 0));
        return profit + rowProfit;
      }, 0);





      setTotalVal({
        stdGoods,
        zeroGoods,
        vatAmt,
        grandTotal,
        totalItems,
        grossWeight,
        netWeight,
        cbm,
        totalProfit,
        totalProfitPercent,
      });
    };

    // Call the function to calculate totals whenever tableRows changes
    calculateTotals();
    console.log(tableRows);
  }, [tableRows, invoiceAddress]);

  const submitSalesOrderForm = async (type) => {
    const form = document.getElementById('new_sales_order');
    const formData = new FormData(form);
    let save_status = formData.get('save_as_proforma');
    let delivery_date = formData.get('delivery_date');
    const salesId = formData.get('sales_id');
    let customerId = formData.get('customer_id');
    let customerRef = formData.get('customer_ref');
    // console.log(customerRef);
    // return;
    if (customerId == '') {
      Swal.fire({
        title: "Failed!",
        text: "Please Select Customer.",
        icon: "error",
        timer: 1500,
        showConfirmButton: false,
      });
      return;
    }

    if (!customerRef || customerRef.trim() === '' || customerRef == null || customerRef == undefined || customerRef == 'null' || customerRef == 'undefined') {
      Swal.fire({
        title: "Failed!",
        text: "Please enter Customer Reference.",
        icon: "error",
        timer: 1500,
        showConfirmButton: false,
      });
      return;
    }

    if (delivery_date == '') {
      formData.set('delivery_date', '0000-00-00');
    }

    let status = 'SO';
    if (save_status == 'on') {
      status = 'PF';
    }
    formData.append(`status`, status);

    if (tableRows.length === 0) {
      Swal.fire({
        title: "Failed!",
        text: "Please Select Product.",
        icon: "error",
        timer: 1500,
        showConfirmButton: false,
      });
      return;
    }

    // Loop through table rows to check quantity
    for (let index = 0; index < tableRows.length; index++) {
      const row = tableRows[index];
      if (!isSpecialLineItem(row.code) && (row.pdtqty === 0 || row.pdtqty === '')) {
        Swal.fire({
          title: "Failed!",
          text: "Please enter quantity for each product.",
          icon: "error",
          timer: 1500,
          showConfirmButton: false,
        });
        return;
      }

      formData.append(`code[${index}]`, row.code);
      formData.append(`packsize[${index}]`, row.pack);
      formData.append(`productSize[${index}]`, row.size);
      formData.append(`qty[${index}]`, row.pdtqty);
      formData.append(`price[${index}]`, row.price);
      formData.append(`cost[${index}]`, row.cost);
      formData.append(`value[${index}]`, row.value);
      formData.append(`Vat[${index}]`, row.vat);
      formData.append(`onSO[${index}]`, row.onSO !== undefined ? row.onSO : 0);
      formData.append(`fstk[${index}]`, row.fstk !== undefined ? row.fstk : 0);
      formData.append(`product_id[${index}]`, row.id !== undefined ? row.id : 0);
      formData.append(`batch_id[${index}]`, row.batch_id !== undefined ? row.batch_id : 0);
      formData.append(`purchase_id[${index}]`, row.purchase_id !== undefined ? row.purchase_id : 0);
      formData.append(`subtotal[${index}]`, row.value !== undefined ? row.value : 0);
    }

    // Append billing/invoice address fields
    formData.set('billing_address_line1', (invoiceAddress && invoiceAddress.billing_address_line1) ? invoiceAddress.billing_address_line1 : '');
    formData.set('billing_address_line2', (invoiceAddress && invoiceAddress.billing_address_line2) ? invoiceAddress.billing_address_line2 : '');
    formData.set('billing_city', (invoiceAddress && invoiceAddress.billing_city) ? invoiceAddress.billing_city : '');
    formData.set('billing_country', (invoiceAddress && invoiceAddress.billing_country) ? invoiceAddress.billing_country : '');
    formData.set('billing_postcode', (invoiceAddress && invoiceAddress.billing_postcode) ? invoiceAddress.billing_postcode : '');
    formData.set('sales_country', (invoiceAddress && invoiceAddress.sales_country) ? invoiceAddress.sales_country : '');

    try {
      const response = await axios.post(`${config.api_url}/ws-update-sales-orderNew`, formData, {
        headers: {
          authorization: `Bearer ${accessToken}`,
        }
      });
      const result = response.data;
      if (result.status === 'success') {
        Swal.fire({
          title: "Success!",
          text: "Order submitted successfully.",
          icon: "success",
          timer: 1500,
          showConfirmButton: false,
        }).then(() => {
          if (type === 'createPO') {
            navigateToOrderHistory(`/CreatePO/${salesId}`);
          } else if (type === 'leterPO') {
            navigateToOrderHistory('/CurrentSalesOrder');
          }
        });
      } else {
        Swal.fire({
          title: "Failed!",
          text: "Sales Order Failed. Try Again",
          icon: "error",
          timer: 1500,
          showConfirmButton: false,
        });
      }
    } catch (error) {
      console.error("Error accepting order:", error);
    }
  };




  const [selectedDeliveryId, setSelectedDeliveryId] = useState('');
  const handleEditData = async (id) => {
    // alert(id);
    //console.log(id);
    const formData = new FormData();
    formData.set('sale_id', id);
    const response = await axios.post(`${config.api_url}/ws-get-sales-by-id`, formData, {
      headers: {
        authorization: `Bearer ${accessToken}`,
      }
    });


    const data = await response.data;
    console.log('API Response data:', response.data);
    console.log('data.sale:', data.sale);
    console.log('data.sale.id:', data.sale?.id);
    console.log('URL id param:', id);

    setSalesDesc(data?.pdtdesc?.bstatus);
    console.log(data?.pdtdesc?.bstatus);



    if (data.product && data.product.length > 0) {


      const newRows = data.product.map(item => {
        const purchaseIds = Array.isArray(item.purchaseIds)
          ? item.purchaseIds
          : item.purchaseIds ? item.purchaseIds.split(',').map(id => parseInt(id, 10)) : [];

        const batchIds = Array.isArray(item.batchIds)
          ? item.batchIds
          : item.batchIds ? item.batchIds.split(',').map(id => parseInt(id, 10)) : [];



        const isDEL001 = item.code === 'DEL001';
        return {
          id: item.id,
          code: item.code,
          product_desc: item.product_desc,
          pack: item.pack,
          size: item.size,
          price: parseFloat(item.price),
          pdtqty: isDEL001 ? 0 : parseInt(item.salesQty, 10),
          salesQty: isDEL001 ? 0 : parseInt(item.salesQty, 10),
          cost: parseFloat(item.cost),
          quantity: isDEL001 ? 0 : parseInt(item.quantity, 10),
          taxrate: (parseFloat(item.item_tax) / parseFloat(item.price)) * 100 || 0,
          vat: parseFloat(item.vat) || 0,
          value: (parseInt(item.salesQty, 10) * parseFloat(item.price)) || 0,
          profit: parseFloat(item.price) - parseFloat(item.cost),
          sales_item_id: item.sales_item_id,
          receivedQty: isDEL001 ? 0 : (item.receivedQty || 0),
          grossWeight: isDEL001 ? 0 : (item.gross_weight || 0),
          netWeight: isDEL001 ? 0 : (item.net_weight || 0),
          cbm: item.cbm,
          notes: item.notes,
          batch_id: batchIds.length > 0 ? batchIds : [0],
          purchase_id: purchaseIds.length > 0 ? purchaseIds : [0], // Ensure it's an array, default to [0]
          mappedPO: '',
          Onpo: isDEL001 ? 0 : (item.totalPO || 0),
          fstock: isDEL001 ? 0 : ((item.totalPO || 0) + (item.quantity || 0)),
          allocation: isDEL001 ? 0 : (item.allocation || 0),
          //freestock: item.freestock || 0,
          freestock: isDEL001 ? 0 : ((item.freestock !== undefined && item.freestock !== null) ? parseInt(data.freestock) + parseInt(item.quantity) : 0),
          freestockcal: isDEL001 ? 0 : ((item.freestock || 0) + parseInt(item.quantity, 10)),
          //freestockcal: (item.freestock !== undefined && item.freestock !== null) ? parseInt(data.freestock) + parseInt(item.quantity) : 0,
          onpurchase: isDEL001 ? 0 : (item.on_purchase || 0),
          onSO: isDEL001 ? 0 : (item.onSO || 0),
        };
      });



      // Update table rows
      setTableRows(prevRows => [...prevRows, ...newRows]);

      if (data.sale.warehouse_id) {
        setSelectedWarehouseId(data.sale.warehouse_id);
      }

      setSalesInfo({
        delivery_date: data.sale.delivery_date,
        delivery_time: data.sale.delivery_time,
        customer_ref: data.sale.customer_ref,
        job_ref: data.sale.job_ref,
        booking_ref: data.sale.booking_ref,
        notes: data.sale.notes,
        status: data.sale.status,
      });

      // Set the proforma checkbox state based on existing status
      setSaveAsProforma(data.sale.status === "PF");


      if (data.sale.customer_id) {

        const selectedOption = await fetchEditCustomerData(setCustomerData, data.sale.customer_id);
        if (selectedOption) {
          setSelectedCustomer(selectedOption);
        }




        console.log('handleEditData calling handleCustomerChange with:', { sale_id: data.sale.id, customer_id: data.sale.customer_id });
        await handleCustomerChange({ value: data.sale.id }, { customer_id: data.sale.customer_id }, data.sale.id, setInvoiceAddress, setDeliveryAddrDropdown, setDeliveryAddresses);

        if (data.sale.delivery_type == "delivery") {

          const addressData = [
            {
              id: data.sale.delivery_id,
              address_line1: data.sale.address_line1,
              address_line2: data.sale.address_line2,
              city: data.sale.city,
              country: data.sale.country,
              post_code: data.sale.post_code
            }
          ];
          setDeliveryType('delivery');

          setDeliveryAddresses(addressData);
          setSelectedDeliveryId(data.sale.delivery_id);
          getDeliveryAddrById({ value: data.sale.delivery_id }, addressData, setInputDeliveryAddresses);

        } else if (data.sale.delivery_type == "collection") {
          setDeliveryType('collection');
          setInputCollectionAddresses({
            address_line1: data.sale.address_line1,
            address_line2: data.sale.address_line2,
            city: data.sale.city,
            country: data.sale.country,
            post_code: data.sale.post_code,
          });
        }



      }


    } else {
      console.error('No product data found.');
    }
  };

  const getProductBatchData = async (id, salesitemId, batch_id, purchase_id) => {
    try {

      setSelectedBatchId([]);
      setSelectedpurchaseId([]);

      setProductBatch([]);


      const formData = new FormData();
      formData.set('product_id', id);
      formData.set('salesitem_id', salesitemId);

      const response = await axios.post(
        `${config.api_url}/ws-batch-info-by-product-idNew`,
        formData,
        {
          headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'multipart/form-data',
          },
        }
      );


      const data = response.data;
      //setProductBatch(data.batch);
      // console.log(data.batch);
      const updatedBatch = data.batch.map(item => ({
        ...item,
        batch_id: batch_id,
      }));
      setProductBatch(updatedBatch);
      setSelectedBatchId(batch_id);
      console.log(updatedBatch);
      setSelectedpurchaseId(purchase_id);

      // Set modalData with product_id for ViewProduct component
      setModalData({ ...data.batch, product_id: id });

      handleOpenPastPurchaseModal(data.batch);

      // Set required quantity from current row
      const matchedRow = tableRows.find((row) => Number(row.id) === Number(id));
      setRequiredQty(matchedRow ? Number(matchedRow.pdtqty) || 0 : 0);

    } catch (error) {
      console.error("Error fetching product batch data:", error);
    }
  };

  const fetchPODetails = async (purchaseId, productCode) => {
    try {
      setPoModalData(null);
      
      const formData = new FormData();
      formData.append('id', purchaseId);

      const response = await axios.post(
        `${config.api_url}/ws-get-purchase-order`,
        formData,
        {
          headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      const data = response.data;
      if (data.headerSection2) {
        let products = (data.products || []);
        
        const seen = new Set();
        products = products.filter(product => {
          const code = (product.code || '').trim().toUpperCase();
          if (!code) return false;
          
          const key = code;
          if (seen.has(key)) {
            return false;
          }
          seen.add(key);
          return true;
        });

        // Store original products with discount data before filtering
        const originalProducts = [...products];

        products = products.map(product => {
          // Prioritize rate over price if price is 0 or empty
          const priceValue = (product.rate && parseFloat(product.rate) > 0) 
            ? product.rate 
            : (product.price && parseFloat(product.price) > 0) 
              ? product.price 
              : (product.cost && parseFloat(product.cost) > 0) 
                ? product.cost 
                : 0;
          
          return {
            code: product.code || '',
            description: product.product_desc || '',
            orderedQty: product.quantity || product.qty || 0,
            price: priceValue
          };
        });

        if (productCode) {
          const normalizedProductCode = productCode.trim().toUpperCase();
          products = products.filter(product => {
            const normalizedCode = (product.code || '').trim().toUpperCase();
            return normalizedCode === normalizedProductCode;
          });
        }

        // Calculate discount from order_discounts table fields
        let totalDiscount = 0;
        if (productCode) {
          // If filtering by product code, calculate discount for that specific product
          const normalizedProductCode = productCode.trim().toUpperCase();
          const matchingProduct = originalProducts.find(p => {
            const normalizedCode = (p.code || '').trim().toUpperCase();
            return normalizedCode === normalizedProductCode;
          });
          
          if (matchingProduct) {
            const retro = parseFloat(matchingProduct.retro || 0);
            const prompt_payment = parseFloat(matchingProduct.prompt_payment || 0);
            const cost_to_serve = parseFloat(matchingProduct.cost_to_serve || 0);
            const off_invoice = parseFloat(matchingProduct.off_invoice || 0);
            const beds_leds = parseFloat(matchingProduct.beds_leds || 0);
            const sugro_retro = parseFloat(matchingProduct.sugro_retro || 0);
            
            totalDiscount = retro + prompt_payment + cost_to_serve + off_invoice + beds_leds + sugro_retro;
          }
        } else {
          // Calculate total discount across all products
          originalProducts.forEach(product => {
            const retro = parseFloat(product.retro || 0);
            const prompt_payment = parseFloat(product.prompt_payment || 0);
            const cost_to_serve = parseFloat(product.cost_to_serve || 0);
            const off_invoice = parseFloat(product.off_invoice || 0);
            const beds_leds = parseFloat(product.beds_leds || 0);
            const sugro_retro = parseFloat(product.sugro_retro || 0);
            
            const productDiscount = retro + prompt_payment + cost_to_serve + off_invoice + beds_leds + sugro_retro;
            totalDiscount += productDiscount;
          });
        }

        // Fallback: check if discount is available in headerSection2
        let discountValue = '';
        if (totalDiscount > 0) {
          discountValue = totalDiscount.toFixed(2);
        } else if (data.headerSection2 && data.headerSection2.discount) {
          discountValue = parseFloat(data.headerSection2.discount) > 0 ? parseFloat(data.headerSection2.discount).toFixed(2) : '';
        }

        const poDetails = {
          poNumber: data.headerSection2.reference_no || `PO${purchaseId}`,
          jobRef: data.headerSection2.job_ref || '',
          notes: data.headerSection2.delivery_notes || data.headerSection2.notes || '',
          discount: discountValue,
          products: products
        };
        setPoModalData(poDetails);
        
        setTimeout(() => {
          const modalElement = document.getElementById('po-details-modal');
          if (modalElement) {
            const modal = new window.bootstrap.Modal(modalElement);
            modal.show();
          }
        }, 100);
      }
    } catch (error) {
      console.error("Error fetching PO details:", error);
      setPoModalData(null);
      Swal.fire({
        title: "Error!",
        text: "Failed to fetch PO details.",
        icon: "error",
        timer: 1500,
        showConfirmButton: false,
      });
    }
  };

  const handlePOClick = (e, purchaseId, productCode) => {
    e.preventDefault();
    if (purchaseId && purchaseId !== 0) {
      fetchPODetails(purchaseId, productCode);
    }
  };

  // Determine whether a batch checkbox should be disabled based on required quantity and current selections
  const isBatchCheckboxDisabled = (item) => {
    const normalizedSelectedIds = Array.isArray(selectedBatchId)
      ? selectedBatchId
      : (selectedBatchId ? [selectedBatchId] : []);

    const getUnalloc = (batchItem) => {
      const qty = Number(batchItem?.qty || 0);
      const alloc = Number(batchItem?.allocation || 0);
      return Math.max(0, qty - alloc);
    };

    const selectedUnallocSum = normalizedSelectedIds.reduce((sum, selId) => {
      const selNum = Number(selId);
      const found = productBatch.find((b) => Number(b.id) === selNum);
      return sum + (found ? getUnalloc(found) : 0);
    }, 0);

    const requirement = Number(requiredQty || 0);
    if (requirement <= 0) return false;

    if (selectedUnallocSum >= requirement) {
      return !normalizedSelectedIds.map((v) => Number(v)).includes(Number(item.id));
    }

    // Allow choosing any batches while requirement not yet fulfilled
    return false;
  };


  const handleOpenPastPurchaseModal = (data) => {
    setModalData(data);
    if (productBatchRef.current) {
      productBatchRef.current();

    }
  };

  const handleBatchAssignementSubmit = (e) => {
    // Compute average net price of selected batches and set as cost
    const productId = productBatch && productBatch[0] ? productBatch[0].product_id : null;
    const normalizedSelectedIds = Array.isArray(selectedBatchId)
      ? selectedBatchId
      : (selectedBatchId ? [selectedBatchId] : []);

    let avgNetPrice = undefined;
    if (productId && normalizedSelectedIds.length > 0) {
      const selectedIdsNum = normalizedSelectedIds.map((v) => Number(v));
      const selectedBatches = productBatch.filter((b) => selectedIdsNum.includes(Number(b.id)));
      const netPrices = selectedBatches
        .map((b) => parseFloat(b.net_price))
        .filter((v) => !isNaN(v));
      if (netPrices.length > 0) {
        const sum = netPrices.reduce((acc, v) => acc + v, 0);
        avgNetPrice = sum / netPrices.length;
      }
    }

    if (productId) {
      setSalesBatchToProductNew(productId, selectedBatchId, selectedpurchaseId, setTableRows, avgNetPrice);
    }
    closeAssignBatchModal();
  };

  const closeAssignBatchModal = (event) => {
    if (AssignBatchModal.current) {
      const bsModal = window.bootstrap.Modal.getInstance(AssignBatchModal.current);
      if (bsModal) bsModal.hide();
    }
  }

  const handleSalesInputChange = (e) => {
    const { name, value } = e.target;
    setSalesInfo((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Keep salesDesc in sync with current table rows mapping state
  useEffect(() => {
    const hasAnyMappedPO = tableRows.some((row) => {
      const batchIdField = row?.batch_id;
      const hasNonZeroBatch = Array.isArray(batchIdField)
        ? batchIdField.some((id) => Number(id) !== 0)
        : (batchIdField !== undefined && batchIdField !== null && Number(batchIdField) !== 0);

      const purchaseIdField = row?.purchase_id;
      const hasPurchaseIds = Array.isArray(purchaseIdField)
        ? purchaseIdField.some((id) => Number(id) !== 0)
        : (purchaseIdField !== undefined && purchaseIdField !== null && Number(purchaseIdField) !== 0);

      const mappedByBatch = hasNonZeroBatch && hasPurchaseIds;
      const mappedByString = row?.mappedPO && String(row.mappedPO).trim() !== '';

      return mappedByBatch || mappedByString;
    });

    setSalesDesc(hasAnyMappedPO ? 'mapped' : 'Unmapped');
  }, [tableRows]);


  const handleSalesBatchEdit = (event) => {
    const { value, dataset, checked } = event.target;
    const batchId = Number(value); // Convert value to a number
    const purchaseId = dataset.purchaseid;
    //const batchId = dataset.batchId;




    setSelectedBatchId(prev => {
      if (checked) {
        console.log(`checked`);
        return [...prev, batchId]; // Add to the array
      } else {
        console.log(`unchecked`);
        return prev.filter(id => id !== batchId); // Remove from the array
      }
    });

    console.log(selectedBatchId);



    setSelectedpurchaseId(prev => {
      if (checked) {
        // If checked, add the purchaseId if not already present
        return [...prev, purchaseId];
      } else {
        // If unchecked, remove the purchaseId
        return prev.filter(id => id !== purchaseId);
      }
    });
  };


  const handleSalesBatchNew = (event, setSelectedBatchId, setSelectedpurchaseId) => {
    const { value, dataset, checked } = event.target;
    // console.log('Previous selectedBatchId:', selectedBatchId);
    const purchaseId = dataset.purchaseid;
    // console.log(purchaseId);
    setSelectedBatchId(prev => {
      if (!Array.isArray(prev)) {
        console.error('prev is not an array:', prev); // This will help identify the issue
        return [value]; // Reset to an array with the current value
      }

      if (checked) {
        console.log(`checked`);
        return [...prev, event.target.value]; // Add to the array
      } else {
        console.log(`unchecked`);
        return prev.filter(id => id !== event.target.value); // Remove from the array
      }
    });

    setSelectedpurchaseId(prev => {

      if (!Array.isArray(prev)) {
        console.error('prev is not an array:', prev); // This will help identify the issue
        return [purchaseId]; // Reset to an array with the current value
      }

      if (checked) {
        console.log(`checked`);
        return [...prev, purchaseId]; // Add to the array
      } else {
        console.log(`unchecked`);
        return prev.filter(id => id !== purchaseId); // Remove from the array
      }
    });


    //setSelectedBatchId(event.target.value);
    //setSelectedpurchaseId(event.target.dataset.purchaseid);
    //setSelectedCost(event.target.dataset.cost);
  };

  const handleShowInvoiceModal = (event) => {
    event.preventDefault();
    const productId = event.currentTarget.getAttribute('data-id');
    GetProductSO(productId);
  };

  const GetProductSO = async (id) => {
    try {
      const formData = new FormData();
      formData.set('product_id', id);

      const response = await axios.post(
        `${config.api_url}/ws-get-product-so`,
        formData,
        {
          headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      setProductSO(response.data.sales);
    } catch (error) {
      console.error("Error fetching product PO data:", error);
    }
  };

  const getProductList = async (id) => {
    try {
      const formData = new FormData();
      formData.set("product_id", id);

      const response = await axios.post(
        `${config.api_url}/ws-get-products`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      const data = response.data;
      setProductBatch(data.products);
      handleOpenProductListModal(data.products);
    } catch (error) {
      console.error("Error fetching product batch data:", error);
    }
  };

  const handleVatValidation = (e) => {
    const value = e.target.value;
    // Allow only alphanumeric characters and limit to 14 characters
    const alphanumericOnly = value.replace(/[^a-zA-Z0-9]/g, '').slice(0, 14);
    if (value !== alphanumericOnly) {
      e.target.value = alphanumericOnly;
    }
  };

  // Validation functions
  const validateQuantity = (value, rowId) => {
    let error = '';
    if (!/^\d{0,6}$/.test(value)) {
      error = 'Max 6 digits allowed';
    }
    setFieldErrors((prev) => ({
      ...prev,
      [rowId]: { ...prev[rowId], qty: error },
    }));
    return !error;
  };

  const validatePrice = (value, rowId) => {
    let error = '';
    if (!/^\d{0,8}(\.\d{0,2})?$/.test(value)) {
      error = 'Max 2 decimal places allowed';
    } else if (parseFloat(value) >= 1000000) {
      error = 'Value must be less than 1,000,000';
    }
    setFieldErrors((prev) => ({
      ...prev,
      [rowId]: { ...prev[rowId], price: error },
    }));
    return !error;
  };

  const isSpecialLineItem = (code) => {
    return code === 'DEL001' || code?.toUpperCase() === 'DEL001';
  };

  const validateCost = (value, rowId) => {
    let error = '';
    if (!/^\d{0,8}(\.\d{0,2})?$/.test(value)) {
      error = 'Max 2 decimal places allowed';
    }
    setFieldErrors((prev) => ({
      ...prev,
      [rowId]: { ...prev[rowId], cost: error },
    }));
    return !error;
  };

  const validateJobRef = (value) => {
    let error = '';
    if (value.length > 100) {
      error = 'Max 100 characters allowed';
    }
    setJobRefError(error);
    return !error;
  };

  const validateBookingRef = (value) => {
    let error = '';
    if (value.length > 100) {
      error = 'Max 100 characters allowed';
    }
    setBookingRefError(error);
    return !error;
  };

  const validateNotes = (value) => {
    let error = '';
    if (value.length > 500) {
      error = 'Max 500 characters allowed';
    }
    setNotesError(error);
    return !error;
  };

  const validateAddressField = (value, fieldName, addressType) => {
    let error = '';
    if (value.length > 50) {
      error = 'Max 50 characters allowed';
    }
    setAddressErrors(prev => ({ ...prev, [`${addressType}_${fieldName}`]: error }));
    return !error;
  };

  const handleSaveClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = document.getElementById('new_sales_order');
    const proformaCheckbox = form?.querySelector("input[name='save_as_proforma']");
    if (proformaCheckbox && proformaCheckbox.checked) {
      submitSalesOrderForm('leterPO');
    } else {
      const modalEl = document.getElementById('save-sales');
      if (modalEl && window.bootstrap && window.bootstrap.Modal) {
        let modal = window.bootstrap.Modal.getInstance(modalEl);
        if (!modal) modal = new window.bootstrap.Modal(modalEl);
        modal.show();
      }
    }
  };


  return (
    <div>
      <div className="modal fade" id="save-sales" tabIndex="-1">
        <div className="modal-dialog modal-md">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">&nbsp;</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <div className="add-product-popup">
                {salesDesc !== "Unmapped" ? (

                  <h3> Do you want to update S.O?</h3>
                ) : (
                  <h3> Do you want to create a P.O?</h3>
                )}

                <hr />
                {salesDesc == "Unmapped" ? (
                  <Link to='NewPurchaseOrder' data-bs-dismiss="modal" aria-label="Close" className="popup-innerbtn-common" onClick={() => submitSalesOrderForm('createPO')} >Yes Create P.O</Link>
                ) : ''}
                <Link to='#' onClick={() => submitSalesOrderForm('leterPO')} data-bs-dismiss="modal" aria-label="Close" className="popup-innerbtn-closebtn">Update</Link>
              </div>
            </div>
          </div>
        </div>
      </div>


      <ProductList
        onViewPastPurchase={(showModal) => {
          productListRef.current = showModal;
        }}
        getProductBatchData={getProductBatchData}
        modalData={modalData}
        setTableRows={setTableRows}
        tableRows={tableRows}
      />
      <Header />
      <div className="breadcrumbs">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-lg-12 col-sm-12"> <a href="#"><i className="fa fa-home"></i></a> &gt; <a href="/Dashboard">Dashboard</a> &gt; <span className="last-crumb">Edit New Sales Order</span> </div>
          </div>
        </div>
      </div>
      <div className="main-container">
        <form id='new_sales_order' autoComplete="off">
          <div className="container-fluid">
            <div className="row">
              <input type="hidden" name="sales_id" value={id} />
              <div className="col-12 col-lg-12 col-sm-12">
                <div className="show-order-area dashboard">
                  <div>
                    <div className="topsearch-area">
                      <div className="row">
                        <div className="col-12 col-lg-6 col-sm-6">

                          <div className="row">
                            <label htmlFor="inputText" className="col-sm-3 col-form-label">Customer:</label>
                            <div className="col-sm-6">
                              <div style={{ position: 'relative', zIndex: '991' }}>
                                <Select
                                  isClearable
                                  name="customer_id"
                                  onChange={(e) => {
                                    console.log('Customer dropdown changed:', { e, id, customer_id: e?.value, selectedCustomer });
                                    setSelectedCustomer(e);
                                    if (e && e.value && id) {
                                      handleCustomerChange(e, { customer_id: e.value }, id, setInvoiceAddress, setDeliveryAddrDropdown, setDeliveryAddresses, setInputDeliveryAddresses);
                                    } else {
                                      console.log('Missing required values:', { e: e?.value, id });
                                    }
                                  }}
                                  options={customerData}
                                  value={selectedCustomer}
                                  placeholder="Select Customer" className='abovedd'
                                />
                              </div>

                            </div>
                          </div>

                        </div>
                        <div className="col-12 col-lg-6 col-sm-6">
                          <div style={{ float: "right" }}>

                            <p>
                              <label className="checkbox">
                                <input
                                  type="checkbox"
                                  name="save_as_proforma"
                                  checked={saveAsProforma}
                                  onChange={(e) => setSaveAsProforma(e.target.checked)}
                                />
                                <span className="default"></span>
                              </label>
                              <span>Save as Proforma</span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>


                    <div class="accordion" id="accordionPanelsStayOpenExample">
                      <div class="accordion-item accordion-item-two">
                        <h2 class="accordion-header" id="panelsStayOpen-headingTwo">
                          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseTwo" aria-expanded="false" aria-controls="panelsStayOpen-collapseTwo">
                            Invoice Address <div className="red">*</div>
                          </button>
                        </h2>
                        <div id="panelsStayOpen-collapseTwo" class="accordion-collapse collapse show" aria-labelledby="panelsStayOpen-headingTwo">
                          <div class="accordion-body">
                            <div className="newsalesorderform" style={{ margin: '0' }}>
                              <div className="row mb-3 padd-l-13px">
                                <div className="col-6 col-lg-6 col-sm-6">
                                  {/* <div className="row mb-3">
                            <div className="col-6 col-lg-3 col-sm-3">
                              <label htmlFor="desc" className="col-form-label"><strong>Invoice Address *</strong></label>
                            </div>
                          </div> */}
                                  <div className="row mb-3">
                                    <div className="col-6 col-lg-3 col-sm-3">
                                      <label htmlFor="desc" className="col-form-label">Address Line 1 </label>
                                    </div>
                                    <div className="col-6 col-lg-9 col-sm-9">
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="addr1"
                                        value={invoiceAddress && invoiceAddress.billing_address_line1 ? invoiceAddress.billing_address_line1 : ''}
                                        onChange={e => {
                                          const value = e.target.value;
                                          if (validateAddressField(value, 'address_line1', 'invoice')) {
                                            setInvoiceAddress({ ...invoiceAddress, billing_address_line1: value });
                                          }
                                        }}
                                        maxLength={50}
                                        autoComplete="off"
                                      />
                                      <FormText error={!!addressErrors.invoice_address_line1}>
                                        {addressErrors.invoice_address_line1}
                                      </FormText>
                                    </div>
                                  </div>
                                  <div className="row mb-3">
                                    <div className="col-6 col-lg-3 col-sm-3">
                                      <label htmlFor="desc" className="col-form-label">Address Line 2 </label>
                                    </div>
                                    <div className="col-6 col-lg-9 col-sm-9">
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="addr2"
                                        value={invoiceAddress && invoiceAddress.billing_address_line2 ? invoiceAddress.billing_address_line2 : ''}
                                        onChange={e => {
                                          const value = e.target.value;
                                          if (validateAddressField(value, 'address_line2', 'invoice')) {
                                            setInvoiceAddress({ ...invoiceAddress, billing_address_line2: value });
                                          }
                                        }}
                                        maxLength={50}
                                        autoComplete="off"
                                      />
                                      <FormText error={!!addressErrors.invoice_address_line2}>
                                        {addressErrors.invoice_address_line2}
                                      </FormText>
                                    </div>
                                  </div>
                                  <div className="row mb-3">
                                    <div className="col-6 col-lg-3 col-sm-3">
                                      <label htmlFor="desc" className="col-form-label">City </label>
                                    </div>
                                    <div className="col-6 col-lg-3 col-sm-3">
                                      <input
                                        type="text"
                                        className="form-control"
                                        value={invoiceAddress && invoiceAddress.billing_city ? invoiceAddress.billing_city : ''}
                                        onChange={e => {
                                          const value = e.target.value;
                                          if (validateAddressField(value, 'city', 'invoice')) {
                                            setInvoiceAddress({ ...invoiceAddress, billing_city: value });
                                          }
                                        }}
                                        maxLength={50}
                                        autoComplete="off"
                                      />
                                      <FormText error={!!addressErrors.invoice_city}>
                                        {addressErrors.invoice_city}
                                      </FormText>
                                    </div>

                                    <div className="col-6 col-lg-3 col-sm-3">
                                      <label htmlFor="desc" className="col-form-label">Country </label>
                                    </div>
                                    <div className="col-6 col-lg-3 col-sm-3">
                                      <input
                                        type="text"
                                        className="form-control"
                                        value={invoiceAddress && invoiceAddress.billing_country ? invoiceAddress.billing_country : ''}
                                        onChange={e => {
                                          const value = e.target.value;
                                          if (validateAddressField(value, 'country', 'invoice')) {
                                            setInvoiceAddress({ ...invoiceAddress, billing_country: value });
                                          }
                                        }}
                                        maxLength={50}
                                        autoComplete="off"
                                      />
                                      <FormText error={!!addressErrors.invoice_country}>
                                        {addressErrors.invoice_country}
                                      </FormText>
                                    </div>
                                  </div>

                                  <div className="row mb-3">
                                    <div className="col-6 col-lg-3 col-sm-3">
                                      <label htmlFor="desc" className="col-form-label">Post Code </label>
                                    </div>
                                    <div className="col-6 col-lg-9 col-sm-9">
                                      <input
                                        type="text"
                                        className="form-control"
                                        value={invoiceAddress && invoiceAddress.billing_postcode ? invoiceAddress.billing_postcode : ''}
                                        onChange={e => {
                                          const value = e.target.value;
                                          if (validateAddressField(value, 'postcode', 'invoice')) {
                                            setInvoiceAddress({ ...invoiceAddress, billing_postcode: value });
                                          }
                                        }}
                                        maxLength={50}
                                        autoComplete="off"
                                      />
                                      <FormText error={!!addressErrors.invoice_postcode}>
                                        {addressErrors.invoice_postcode}
                                      </FormText>
                                    </div>
                                  </div>
                                  <div className="row mb-3">
                                    <div className="col-6 col-lg-3 col-sm-3">
                                      <label htmlFor="desc" className="col-form-label">VAT </label>
                                    </div>
                                    <div className="col-6 col-lg-9 col-sm-9">
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="vat"
                                        value={invoiceAddress && invoiceAddress.vat_number ? invoiceAddress.vat_number : ''}
                                        onChange={e =>
                                          setInvoiceAddress({
                                            ...invoiceAddress,
                                            vat_number: e.target.value
                                          })
                                        }
                                        onInput={handleVatValidation}
                                      />
                                    </div>
                                  </div>
                                  {/* <div className="row">
                                    <div className="col-6 col-lg-3 col-sm-3">
                                      <label htmlFor="desc" className="col-form-label">Warehouse </label>
                                    </div>
                                    <div className="col-6 col-lg-9 col-sm-9">
                                      <Select
                                        name='warehouse_id' className='dynamicselect'
                                        id='warehouse_id'
                                        isClearable
                                        options={warehouseData}
                                        placeholder="Select Warehouse"
                                        value={warehouseData.find(warehouse => warehouse.value === selectedWarehouseId)} // Set the selected value
                                        onChange={option => setSelectedWarehouseId(option?.value || null)} // Update state on selection
                                      />
                                    </div>
                                  </div> */}
                                </div>

                                <div className="col-6 col-lg-6 col-sm-6">

                                  <div className="row mb-3">
                                    <div className="col-3 col-lg-3 col-sm-3">
                                      <label className="col-form-label padd-left-50">
                                        Customer Address
                                      </label>
                                    </div>
                                    <div className="col-1 col-lg-1 col-sm-1" style={{ paddingTop: '8px' }}>

                                      <input
                                        type="radio"
                                        name="delivery_type"
                                        value="delivery"
                                        checked={deliveryType === 'delivery'}
                                        onChange={handleDeliveryandCollectionAddress}
                                        style={{ float: "left" }}
                                      />
                                    </div>


                                    <div className="col-3 col-lg-3 col-sm-3">
                                      <label className="col-form-label padd-left-50">
                                        Collection Address
                                      </label>
                                    </div>
                                    <div className="col-3 col-lg-3 col-sm-3" style={{ paddingTop: '8px' }}>

                                      <input
                                        type="radio"
                                        name="delivery_type"
                                        value="collection"
                                        checked={deliveryType === 'collection'}
                                        onChange={handleDeliveryandCollectionAddress}
                                        style={{ float: "left" }}
                                      />
                                    </div>

                                  </div>

                                  {deliveryType === 'delivery' && (
                                    <div>
                                      <div className="row mb-3">
                                        <div className="col-6 col-lg-3 col-sm-3">
                                          <label htmlFor="desc" className="col-form-label"><strong>Delivery Address </strong></label>
                                        </div>
                                        <div className="col-6 col-lg-9 col-sm-9">
                                          <select name="delivery_id" className='form-select orgselect' value={selectedDeliveryId} onChange={(e) => {
                                            setSelectedDeliveryId(e.target.value); // Update state on change
                                            getDeliveryAddrById(e, deliveryAddrDropdown, setInputDeliveryAddresses);
                                          }}>
                                            <option value="">Select</option>
                                            {deliveryAddrDropdown && Array.isArray(deliveryAddrDropdown) && deliveryAddrDropdown.map((option) => (
                                              <option key={option.id} value={option.id}>
                                                {option.address_line1}
                                              </option>
                                            ))}
                                          </select>
                                        </div>
                                      </div>
                                      <div className="row mb-3">
                                        <div className="col-4 col-lg-3 col-sm-3">
                                          <label htmlFor="desc" className="col-form-label">Address Line 1 </label>
                                        </div>
                                        <div className="col-8 col-lg-9 col-sm-9">
                                          <input
                                            type="text"
                                            name="addr1"
                                            className="form-control"
                                            value={inputDeliveryAddresses && inputDeliveryAddresses.address_line1 ? inputDeliveryAddresses.address_line1 : ''}
                                            onChange={e => {
                                              const value = e.target.value;
                                              if (validateAddressField(value, 'address_line1', 'delivery')) {
                                                setInputDeliveryAddresses({ ...inputDeliveryAddresses, address_line1: value });
                                              }
                                            }}
                                            maxLength={50}
                                            autoComplete="off"
                                          />
                                          <FormText error={!!addressErrors.delivery_address_line1}>
                                            {addressErrors.delivery_address_line1}
                                          </FormText>
                                        </div>
                                      </div>
                                      <div className="row mb-3">
                                        <div className="col-4 col-lg-3 col-sm-3">
                                          <label htmlFor="desc" className="col-form-label">Address Line 2 </label>
                                        </div>
                                        <div className="col-8 col-lg-9 col-sm-9">
                                          <input
                                            type="text"
                                            name="addr2"
                                            className="form-control"
                                            value={inputDeliveryAddresses && inputDeliveryAddresses.address_line2 ? inputDeliveryAddresses.address_line2 : ''}
                                            onChange={e => {
                                              const value = e.target.value;
                                              if (validateAddressField(value, 'address_line2', 'delivery')) {
                                                setInputDeliveryAddresses({ ...inputDeliveryAddresses, address_line2: value });
                                              }
                                            }}
                                            maxLength={50}
                                            autoComplete="off"
                                          />
                                          <FormText error={!!addressErrors.delivery_address_line2}>
                                            {addressErrors.delivery_address_line2}
                                          </FormText>
                                        </div>
                                      </div>
                                      <div className="row mb-3">
                                        <div className="col-4 col-lg-3 col-sm-3">
                                          <label htmlFor="desc" className="col-form-label">City </label>
                                        </div>
                                        <div className="col-8 col-lg-3 col-sm-3">
                                          <input
                                            type="text"
                                            name="city"
                                            className="form-control"
                                            value={inputDeliveryAddresses && inputDeliveryAddresses.city ? inputDeliveryAddresses.city : ''}
                                            onChange={e => {
                                              const value = e.target.value;
                                              if (validateAddressField(value, 'city', 'delivery')) {
                                                setInputDeliveryAddresses({ ...inputDeliveryAddresses, city: value });
                                              }
                                            }}
                                            maxLength={50}
                                            autoComplete="off"
                                          />
                                          <FormText error={!!addressErrors.delivery_city}>
                                            {addressErrors.delivery_city}
                                          </FormText>
                                        </div>

                                        <div className="col-4 col-lg-3 col-sm-3">
                                          <label htmlFor="desc" className="col-form-label">Country </label>
                                        </div>
                                        <div className="col-8 col-lg-3 col-sm-3">
                                          <input
                                            type="text"
                                            name="country"
                                            className="form-control"
                                            value={inputDeliveryAddresses && inputDeliveryAddresses.country ? inputDeliveryAddresses.country : ''}
                                            onChange={e => {
                                              const value = e.target.value;
                                              if (validateAddressField(value, 'country', 'delivery')) {
                                                setInputDeliveryAddresses({ ...inputDeliveryAddresses, country: value });
                                              }
                                            }}
                                            maxLength={50}
                                            autoComplete="off"
                                          />
                                          <FormText error={!!addressErrors.delivery_country}>
                                            {addressErrors.delivery_country}
                                          </FormText>
                                        </div>

                                      </div>

                                      <div className="row mb-3">
                                        <div className="col-4 col-lg-3 col-sm-3">
                                          <label htmlFor="desc" className="col-form-label">Post Code </label>
                                        </div>
                                        <div className="col-8 col-lg-9 col-sm-9">
                                          <input
                                            type="text"
                                            name="post_code"
                                            className="form-control"
                                            value={inputDeliveryAddresses && inputDeliveryAddresses.post_code ? inputDeliveryAddresses.post_code : ''}
                                            onChange={e => {
                                              const value = e.target.value;
                                              if (validateAddressField(value, 'postcode', 'delivery')) {
                                                setInputDeliveryAddresses({ ...inputDeliveryAddresses, post_code: value });
                                              }
                                            }}
                                            maxLength={50}
                                            autoComplete="off"
                                          />
                                          <FormText error={!!addressErrors.delivery_postcode}>
                                            {addressErrors.delivery_postcode}
                                          </FormText>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  {deliveryType === 'collection' && (
                                    <div>
                                      <div className="row mb-3">
                                        <div className="col-3">
                                          <label className="col-form-label">Address Line 1 </label>
                                        </div>
                                        <div className="col-9">
                                          <input
                                            type="text"
                                            name="addr1"
                                            className="form-control"
                                            value={inputCollectionAddresses.address_line1}
                                            onChange={(e) => {
                                              const value = e.target.value;
                                              if (validateAddressField(value, 'address_line1', 'collection')) {
                                                setInputCollectionAddresses({ ...inputCollectionAddresses, address_line1: value });
                                              }
                                            }}
                                            maxLength={50}
                                            autoComplete="off"
                                          />
                                          <FormText error={!!addressErrors.collection_address_line1}>
                                            {addressErrors.collection_address_line1}
                                          </FormText>
                                        </div>
                                      </div>
                                      <div className="row mb-3">
                                        <div className="col-3">
                                          <label className="col-form-label">Address Line 2 </label>
                                        </div>
                                        <div className="col-9">
                                          <input
                                            type="text"
                                            name="addr2"
                                            className="form-control"
                                            value={inputCollectionAddresses.address_line2}
                                            onChange={(e) => {
                                              const value = e.target.value;
                                              if (validateAddressField(value, 'address_line2', 'collection')) {
                                                setInputCollectionAddresses({ ...inputCollectionAddresses, address_line2: value });
                                              }
                                            }}
                                            maxLength={50}
                                            autoComplete="off"
                                          />
                                          <FormText error={!!addressErrors.collection_address_line2}>
                                            {addressErrors.collection_address_line2}
                                          </FormText>
                                        </div>
                                      </div>
                                      <div className="row mb-3">
                                        <div className="col-3">
                                          <label className="col-form-label">City </label>
                                        </div>
                                        <div className="col-3">
                                          <input
                                            type="text"
                                            name="city"
                                            className="form-control"
                                            value={inputCollectionAddresses.city}
                                            onChange={(e) => {
                                              const value = e.target.value;
                                              if (validateAddressField(value, 'city', 'collection')) {
                                                setInputCollectionAddresses({ ...inputCollectionAddresses, city: value });
                                              }
                                            }}
                                            maxLength={50}
                                            autoComplete="off"
                                          />
                                          <FormText error={!!addressErrors.collection_city}>
                                            {addressErrors.collection_city}
                                          </FormText>
                                        </div>

                                        <div className="col-3">
                                          <label className="col-form-label">Country </label>
                                        </div>
                                        <div className="col-3">
                                          <input
                                            type="text"
                                            name="country"
                                            className="form-control"
                                            value={inputCollectionAddresses.country}
                                            onChange={(e) => {
                                              const value = e.target.value;
                                              if (validateAddressField(value, 'country', 'collection')) {
                                                setInputCollectionAddresses({ ...inputCollectionAddresses, country: value });
                                              }
                                            }}
                                            maxLength={50}
                                            autoComplete="off"
                                          />
                                          <FormText error={!!addressErrors.collection_country}>
                                            {addressErrors.collection_country}
                                          </FormText>
                                        </div>
                                      </div>

                                      <div className="row mb-3">
                                        <div className="col-3">
                                          <label className="col-form-label">Post Code </label>
                                        </div>
                                        <div className="col-9">
                                          <input
                                            type="text"
                                            name="post_code"
                                            className="form-control"
                                            value={inputCollectionAddresses.post_code}
                                            onChange={(e) => {
                                              const value = e.target.value;
                                              if (validateAddressField(value, 'postcode', 'collection')) {
                                                setInputCollectionAddresses({ ...inputCollectionAddresses, post_code: value });
                                              }
                                            }}
                                            maxLength={50}
                                            autoComplete="off"
                                          />
                                          <FormText error={!!addressErrors.collection_postcode}>
                                            {addressErrors.collection_postcode}
                                          </FormText>
                                        </div>
                                      </div>
                                    </div>
                                  )}



                                  <div className="row mb-3">
                                    <div className="col-4 col-lg-3 col-sm-3">
                                      <label htmlFor="desc" className="col-form-label">Delivery Date </label>
                                    </div>
                                    <div className="col-6 col-lg-3 col-sm-3">
                                      <CustomDateInput
                                        name="delivery_date"
                                        id="delivery_date"
                                        value={salesInfo.delivery_date}
                                        onChange={handleSalesInputChange}
                                      />
                                    </div>
                                    <div className="col-6 col-lg-3 col-sm-3">
                                      <label htmlFor="desc" className="col-form-label">Delivery Time </label>
                                    </div>
                                    <div className="col-6 col-lg-3 col-sm-3">
                                      <input type="time" className="form-control" name="delivery_time" id="delivery_time" value={salesInfo.delivery_time} onChange={handleSalesInputChange} />
                                    </div>
                                  </div>
                                  <div className="row mb-3">
                                    <div className="col-6 col-lg-3 col-sm-3">
                                      <label htmlFor="desc" className="col-form-label">Customer Ref <span className="red">*</span></label>
                                    </div>
                                    <div className="col-6 col-lg-9 col-sm-9">
                                      <input type="text" className="form-control" name="customer_ref" id="customer_ref" value={salesInfo.customer_ref} onChange={handleSalesInputChange} />
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="col-6 col-lg-3 col-sm-3">
                                      <label htmlFor="desc" className="col-form-label">Job Ref </label>
                                    </div>
                                    <div className="col-6 col-lg-3 col-sm-3">
                                      <input
                                        type="text"
                                        className="form-control"
                                        name="job_ref"
                                        id="job_ref"
                                        value={salesInfo.job_ref}
                                        onChange={(e) => {
                                          const value = e.target.value;
                                          validateJobRef(value);
                                          handleSalesInputChange(e);
                                        }}
                                        maxLength={100}
                                      />
                                      <FormText error={!!jobRefError}>{jobRefError}</FormText>
                                    </div>
                                    <div className="col-6 col-lg-3 col-sm-3">
                                      <label htmlFor="desc" className="col-form-label">Booking Ref </label>
                                    </div>
                                    <div className="col-6 col-lg-3 col-sm-3">
                                      <input
                                        type="text"
                                        className="form-control"
                                        name="booking_ref"
                                        id="booking_ref"
                                        value={salesInfo.booking_ref}
                                        onChange={(e) => {
                                          const value = e.target.value;
                                          validateBookingRef(value);
                                          handleSalesInputChange(e);
                                        }}
                                        maxLength={100}
                                      />
                                      <FormText error={!!bookingRefError}>{bookingRefError}</FormText>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="topsearch-area">
                      <div className="row">
                        <div className="col-12 col-lg-5 col-sm-5">
                          <div className="col-12 col-lg-12 col-sm-12">
                            <div className='row'>
                              <label htmlFor="inputText" className=" col-form-label col-12 col-lg-4 col-sm-4" >
                                Product:
                              </label>
                              <div className="col-12 col-lg-8 col-sm-8">
                                {/* <Select
                                  isClearable
                                  onChange={(e) => handleSalesProductAddNew(e, tableRows, setTableRows)}
                                  options={productData}
                                  placeholder="Select Product"
                                /> */}

                                <buttion
                                  to="#"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    getProductList();
                                  }} className="create-catalogue-btn-left"
                                >
                                  Add New Product
                                </buttion>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-12 col-lg-7 col-sm-7">&nbsp;</div>
                      </div>
                    </div>
                    <div className="verical-scrl-wrapper common-table newsalesorder-table" id="style-3">
                      <table className="table table-bordered dataTable" id="dsTable">
                        <thead>
                          <tr>
                            <th>Code</th>
                            <th>Description</th>
                            <th>Pk</th>
                            <th>Size</th>
                            <th>Case Qty</th>
                            <th>Selling Price</th>
                            <th>Cost Price</th>
                            <th>Value</th>
                            <th>Profit</th>
                            <th>VAT</th>
                            <th>Stock</th>
                            <th>On PO</th>
                            <th>F.Stk</th>
                            <th>Mapped P.O No.</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {(!tableRows || tableRows.length === 0) ? (
                            <tr style={{ textAlign: "center" }}>
                              <td colSpan={13}>No product added</td>
                            </tr>
                          ) : (
                            tableRows.map((row) => (
                              <tr key={row.id}>
                                <td>
                                  <input type="hidden" name="product_id[]" value={row.id} />
                                  <input type="hidden" name="code[]" value={row.code} />
                                  <input type="hidden" name="batch_id[]" value={row.batch_id} />
                                  <input type="hidden" name="purchase_id[]" value={row.purchase_id} />
                                  <input type="hidden" name="code[]" value={row.code} />
                                  {isSpecialLineItem(row.code) ? (
                                    <span>{row.code}</span>
                                  ) : (
                                    <Link
                                      to="#"
                                      onClick={() => getProductBatchData(row.id, row.sales_item_id, row.batch_id, row.purchase_id)}
                                      data-bs-toggle="modal"
                                      data-bs-target="#viw-pst-invs"
                                    >
                                      {row.code}
                                    </Link>
                                  )}
                                </td>
                                <td>
                                  <p className="cut-text">
                                    {isSpecialLineItem(row.code) ? (
                                      <span>{row.product_desc}</span>
                                    ) : (
                                      <a
                                        data-bs-toggle="modal"
                                        className="applybtn"
                                        data-id={row.id}
                                        data-bs-target="#viewproduct"
                                        onClick={() => setSelectedProductId(row.id)}
                                      >
                                        {row.product_desc}
                                      </a>
                                    )}
                                  </p>
                                </td>
                                <td>
                                  <input
                                    type="hidden"
                                    name="packsize[]"
                                    value={row.pack}
                                  />{" "}
                                  {row.pack}
                                </td>
                                <td>
                                  <input
                                    type="hidden"
                                    name="productSize[]"
                                    value={row.size}
                                  />{" "}
                                  {row.size}
                                </td>
                                <td>
                                  <input
                                    type="text"
                                    name="qty[]"
                                    value={row.pdtqty}
                                    className="form-control qtyinputbox"
                                    onFocus={(e) => e.target.select()}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      if (isSpecialLineItem(row.code)) {
                                        setTableRows((prev) => prev.map(r => r.id === row.id ? { ...r, pdtqty: value } : r));
                                      } else if (validateQuantity(value, row.id)) {
                                        handleInputChangeIneditSales(e, row.id, "pdtqty", setTableRows);
                                      } else {
                                        // Still update value for controlled input
                                        setTableRows((prev) => prev.map(r => r.id === row.id ? { ...r, pdtqty: value } : r));
                                      }
                                    }}
                                    autoComplete='off'
                                    disabled={isSpecialLineItem(row.code)}
                                  />
                                  <FormText error={!!(fieldErrors[row.id]?.qty)}>
                                    {fieldErrors[row.id]?.qty}
                                  </FormText>
                                </td>
                                <td>
                                  <input
                                    type="text"
                                    name="price[]"
                                    className="form-control qtyinputbox"
                                    value={row.price}
                                    onFocus={(e) => e.target.select()}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      if (isSpecialLineItem(row.code)) {
                                        const numValue = parseFloat(value) || 0;
                                        setTableRows((prev) => prev.map(r => {
                                          if (r.id === row.id) {
                                            return { ...r, price: value, cost: numValue, value: numValue };
                                          }
                                          return r;
                                        }));
                                      } else if (validatePrice(value, row.id)) {
                                        handleInputChangeInSalesNew(e, row.id, "price", setTableRows);
                                      } else {
                                        setTableRows((prev) => prev.map(r => r.id === row.id ? { ...r, price: value } : r));
                                      }
                                    }}
                                    step="0.01"
                                    autoComplete='off'
                                  />
                                  <FormText error={!!(fieldErrors[row.id]?.price)}>
                                    {fieldErrors[row.id]?.price}
                                  </FormText>
                                </td>
                                <td>
                                  <input
                                    type="text"
                                    name="cost[]"
                                    className="form-control qtyinputbox"
                                    value={row.cost && parseFloat(row.cost) !== 0 ? row.cost : ''}
                                    onFocus={(e) => e.target.select()}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      if (isSpecialLineItem(row.code)) {
                                        setTableRows((prev) => prev.map(r => r.id === row.id ? { ...r, cost: value } : r));
                                      } else if (validateCost(value, row.id)) {
                                        handleInputChangeInSalesNew(e, row.id, "cost", setTableRows);
                                      } else {
                                        // Still update value for controlled input
                                        setTableRows((prev) => prev.map(r => r.id === row.id ? { ...r, cost: value } : r));
                                      }
                                    }}
                                    step="0.01"
                                    autoComplete='off'
                                    disabled={isSpecialLineItem(row.code)}
                                  />
                                  <FormText error={!!(fieldErrors[row.id]?.cost)}>
                                    {fieldErrors[row.id]?.cost}
                                  </FormText>
                                </td>
                                <td>
                                  <input type="hidden" name="sales_item_id[]" value={row.sales_item_id ? row.sales_item_id : 0} />
                                  <input type="hidden" name="value[]" value={(parseFloat(row.value) || 0).toFixed(2)} />
                                  {(parseFloat(row.value) || 0).toFixed(2)}
                                </td>
                                <td>
                                  <input type="hidden" name="profit[]" value={row.cost > 0
                                    ? (((row.price - row.cost) / row.cost) * 100).toFixed(2)
                                    : "0.00"} />
                                  {row.cost > 0
                                    ? (((row.price - row.cost) / row.cost) * 100).toFixed(2)
                                    : "0.00"}
                                </td>
                                <td>
                                  <input type="hidden" name="vat[]" value={isSpecialLineItem(row.code) ? "0.00" : (((parseFloat(row.value) || 0) / 100) * (parseFloat(row.vat) || 0)).toFixed(2)} />
                                  {isSpecialLineItem(row.code) ? "0.00" : (((parseFloat(row.value) || 0) / 100) * (parseFloat(row.vat) || 0)).toFixed(2)}
                                </td>
                                <td>
                                  <input type="hidden" name="stock[]" value={row.receivedQty} />
                                  {row.quantity}
                                </td>
                                <td>
                                  <input type="hidden" name="onPO[]" />
                                  {/*row.Onpo*/}
                                  {row.onpurchase}
                                </td>
                                <td>
                                  <input type="hidden" name="onSO[]" value="0" />
                                  {row.freestockcal}
                                </td>
                                <td>
                                  <input type="hidden" name="fstk[]" value="0" />
                                  {row.batch_id !== 0 ? (
                                    row.purchase_id && row.purchase_id.length > 0 ? (
                                      row.purchase_id
                                        .filter(id => id !== 0) // Filter out the '0' values first
                                        .map((id, index, filteredArray) => (
                                          <a 
                                            key={index}
                                            href="#" 
                                            onClick={(e) => handlePOClick(e, id, row.code)}
                                            style={{ cursor: 'pointer', textDecoration: 'underline', color: '#0066cc' }}
                                          >
                                            PO{id}
                                            {index < filteredArray.length - 1 ? ', ' : ''}
                                          </a>
                                        ))
                                    ) : ''
                                  ) : (
                                    row.mappedPO ? (
                                      <a 
                                        href="#" 
                                        onClick={(e) => {
                                          e.preventDefault();
                                          let poId = row.mappedPO.replace(/PO/gi, '').trim();
                                          if (row.purchase_id && Array.isArray(row.purchase_id) && row.purchase_id.length > 0) {
                                            poId = row.purchase_id[0];
                                          }
                                          if (poId && poId !== '0') {
                                            handlePOClick(e, poId, row.code);
                                          }
                                        }}
                                        style={{ cursor: 'pointer', textDecoration: 'underline', color: '#0066cc' }}
                                      >
                                        {row.mappedPO}
                                      </a>
                                    ) : ''
                                  )}
                                </td>
                                <td>
                                  <Link To="#" value="Remove" onClick={() => removeRow(row.id, setTableRows)}>
                                    <i className="fa fa-trash"></i>
                                  </Link>
                                </td>
                                <input type="hidden" name="stdGoods" value={totalVal.stdGoods.toFixed(2)} />
                                <input type="hidden" name="vatAmt" value={totalVal.vatAmt.toFixed(2)} />
                                <input type="hidden" name="zeroGoods" value={totalVal.zeroGoods.toFixed(2)} />
                                <input type="hidden" name="grandTotal" value={totalVal.grandTotal.toFixed(2)} />
                                <input type="hidden" name="totalItems" value={totalVal.totalItems} />
                                <input type="hidden" name="grossWeight" value={totalVal.grossWeight} />
                                <input type="hidden" name="netWeight" value={totalVal.netWeight} />
                                <input type="hidden" name="cube" value={totalVal.cbm} />
                                <input type="hidden" name="grossProfit" value={totalVal.totalProfit.toFixed(2)} />
                                <input type="hidden" name="grossProfitPercent" value={totalVal.totalProfitPercent.toFixed(2)} />
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>
                    <div className="newsalesorderftr">
                      <div className="row">
                        <div className="col-6 col-lg-3 col-sm-3">Std Rated : {totalVal.stdGoods.toFixed(2)} </div>
                        <div className="col-6 col-lg-3 col-sm-3">VAT Amount : {totalVal.vatAmt.toFixed(2)} </div>
                        <div className="col-6 col-lg-3 col-sm-3">Zero Rated : {totalVal.zeroGoods.toFixed(2)}</div>
                        <div className="col-6 col-lg-3 col-sm-3">Grand Total : {totalVal.grandTotal.toFixed(2)}</div>
                      </div>
                    </div>
                    <div className="newsalesorderftr">
                      <div className="row">
                        <div className="col-6 col-lg-3 col-sm-3">Total Items :  {totalVal.totalItems} </div>
                        <div className="col-6 col-lg-3 col-sm-3">Gross Weight : {totalVal.grossWeight} KGS</div>
                        <div className="col-6 col-lg-3 col-sm-3">Net Weight : {totalVal.netWeight} KGS</div>
                        <div className="col-6 col-lg-3 col-sm-3">Cube : {totalVal.cbm} M3</div>
                      </div>
                    </div>
                    <button className='clickherebtn'>Show Gross Profit</button>
                    <div class="data">
                      <div className="newsalesorderftr">
                        <div className="row">
                          <div className="col-6 col-lg-6 col-sm-6">Gross Profit : {totalVal.totalProfit.toFixed(2)}</div>
                          <div className="col-6 col-lg-6 col-sm-6">Gross Profit % : {totalVal.totalProfitPercent.toFixed(2)}%</div>
                        </div>
                      </div>
                    </div>

                    <div>
                      <div className="row mb-3">
                        <div className="col-6 col-lg-2 col-sm-2">
                          <label htmlFor="desc" className="col-form-label">Notes :</label></div>
                        <div className="col-6 col-lg-4 col-sm-4">
                          <textarea
                            className="form-control"
                            name="notes"
                            id="notes"
                            value={salesInfo.notes}
                            onChange={(e) => {
                              const value = e.target.value;
                              validateNotes(value);
                              setSalesInfo(prev => ({ ...prev, notes: value }));
                            }}
                            placeholder="Leave a comment here"
                            style={{ height: '100px' }}
                            maxLength={500}
                          />
                          <FormText error={!!notesError}>{notesError}</FormText>
                        </div>
                      </div>
                    </div>
                    <a href="#" className="popup-innerbtn-common" onClick={handleSaveClick}>Save Sales Order</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <ViewProduct product_id={selectedProductId} />
      <div className="modal fade" id="viw-pst-invs" tabIndex="-1" ref={AssignBatchModal}>
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">All Batches :  {productBatch[0]?.product_desc}  ({productBatch[0]?.code})</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <div className="partialbox">
                <h3>
                  <a href='#' data-bs-toggle="modal" data-bs-target="#vw-pst-ordr" data-id={productBatch[0]?.product_id} onClick={handleShowInvoiceModal}>View Past Invoices</a></h3>
                <form id='selectBatchForm'>
                  <div className="verical-scrl-wrapper partialbox-table-wrapper" id="style-3">
                    <table className="table table-bordered dataTable">
                      <thead>
                        <tr>
                          <th>&nbsp;</th>
                          <th>P.O. Qty</th>
                          <th>Sold Qty</th>
                          <th>Bal Qty</th>
                          <th>Alloc</th>
                          <th>UnAlloc</th>
                          <th>PO No.</th>
                          <th>Net Price</th>
                          <th>Received</th>
                        </tr>
                      </thead>
                      <tbody>
                        {productBatch && productBatch.map((item, index) => (
                          <tr key={index}>
                            <td>
                              <input
                                type="checkbox"
                                id={`batch_${item.id}`}
                                name="select_batch"
                                value={item.id}
                                data-purchaseid={item.purchase_id}
                                data-unallocation={item.qty - item.allocation}
                                data-cost={item.cost_price}
                                onChange={(e) => handleSalesBatchNew(e, setSelectedBatchId, setSelectedpurchaseId)}
                                checked={Array.isArray(selectedBatchId) && selectedBatchId.includes(item.id)}
                                style={{ marginRight: '10px' }}
                                disabled={isBatchCheckboxDisabled(item)}
                              />
                            </td>
                            <td>{item.qty}</td>
                            <td>{item.sale_qty}</td>
                            <td>{item.qty - item.sale_qty}</td>
                            <td>{item.allocation}</td>
                            <td>{item.qty - item.allocation}</td>
                            <td>
                              <a href={`/editNewPurchaseOrder/${item.purchase_id}`}>{item.reference_no}</a>
                            </td>
                            <td>{item.net_price}</td>
                            <td>{item.received_quantity}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <a className="popup-innerbtn-common" onClick={handleBatchAssignementSubmit} style={{ marginTop: '10px' }} > Submit</a>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="modal fade" id="vw-pst-ordr" tabIndex="-1">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">&nbsp;All Invoices of Product : {productBatch[0]?.product_desc}  ({productBatch[0]?.code})</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <div className="partialbox">
                <table className="table table-bordered dataTable">
                  <thead>
                    <tr>
                      <th>SO#</th>
                      <th>Qty</th>
                      <th>Price </th>
                      <th>Delivered on</th>
                    </tr>
                  </thead>
                  <tbody>
                    {productSO && productSO.map((item, index) => (
                      <tr>
                        <td>{item.reference_no}</td>
                        <td>{item.quantity}</td>
                        <td>{item.price}</td>
                        <td>{item.delivery_date}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div 
        className="modal fade" 
        id="po-details-modal" 
        tabIndex="-1" 
        ref={poModalRef}
        onHidden={() => setPoModalData(null)}
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Purchase Order Details</h5>
              <button 
                type="button" 
                className="btn-close" 
                data-bs-dismiss="modal" 
                aria-label="Close"
                onClick={() => setPoModalData(null)}
              ></button>
            </div>
            <div className="modal-body">
              {poModalData && (
                <div className="po-details-container">
                  {/* 1. PO Number */}
                  <div className="row mb-3">
                    <div className="col-md-12">
                      <strong>PO Number:</strong> {poModalData.poNumber}
                    </div>
                  </div>
                  
                  {/* 2. Ordered Qty */}
                  {poModalData.products && poModalData.products.length > 0 && (
                    poModalData.products.map((product, index) => (
                      <div key={index}>
                        {poModalData.products.length > 1 && (
                          <div className="row mb-2">
                            <div className="col-md-12">
                              <strong>Product {index + 1}</strong>
                            </div>
                          </div>
                        )}
                        <div className="row mb-3">
                          <div className="col-md-12">
                            <strong>Ordered Qty:</strong> {product.orderedQty}
                          </div>
                        </div>
                        
                        {/* 3. Price */}
                        <div className="row mb-3">
                          <div className="col-md-12">
                            <strong>Price:</strong> {parseFloat(product.price || 0).toFixed(2)}
                          </div>
                        </div>
                        {index < poModalData.products.length - 1 && <hr className="my-3" />}
                      </div>
                    ))
                  )}
                  
                  {/* 4. Job Ref Number */}
                  {poModalData.jobRef && (
                    <div className="row mb-3">
                      <div className="col-md-12">
                        <strong>Job Ref Number:</strong> {poModalData.jobRef}
                      </div>
                    </div>
                  )}
                  
                  {/* 5. Notes */}
                  {poModalData.notes && (
                    <div className="row mb-3">
                      <div className="col-md-12">
                        <strong>Notes:</strong> {poModalData.notes}
                      </div>
                    </div>
                  )}
                  
                  {/* 6. Discount (If not available keep blank) */}
                  {poModalData.discount && (
                    <div className="row mb-3">
                      <div className="col-md-12">
                        <strong>Discount:</strong> {poModalData.discount}
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
            <div className="modal-footer">
              <button 
                type="button" 
                className="btn btn-secondary" 
                data-bs-dismiss="modal"
                onClick={() => setPoModalData(null)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default NewSalesOrderEdit;
